import React from 'react';
import { motion } from 'framer-motion';

function ManagedPortfolios() {
  const advantages = [
    { title: 'Diversified & Efficient', points: ['Strategic core exposure', 'ETF / fund curation', 'Low total cost'] },
    { title: 'Dynamic Oversight', points: ['Tactical tilts', 'Ongoing due‑diligence', 'Disciplined rebalancing'] },
    { title: 'Transparent Reporting', points: ['Performance & attribution', 'Risk metrics', 'Quarterly reviews'] },
    { title: 'Aligned to You', points: ['Risk band options', 'Income or growth focus', 'Tax‑aware implementation'] },
  ];

  return (
    <div className="min-h-screen bg-white">
      <section className="relative h-[55vh] overflow-hidden">
        <img src="/images/two-stock-exchange-traders-discussing-dynamic-investment-graph-sellable_31965-313820.jpg_yeupoj.jpg" alt="Managed portfolios" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/60 to-black/80" />
        <div className="relative z-10 flex h-full items-center justify-center text-center px-6">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <h1 className="text-white text-5xl font-light mb-4">Managed <span className="font-semibold text-[#fbbf24]">Portfolios</span></h1>
            <p className="text-white/90 text-xl max-w-3xl">Professionally built, diversified portfolios designed for clarity, cost and consistency.</p>
          </motion.div>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div data-aos="fade-up" className="text-center mb-14">
            <h2 className="text-3xl font-semibold text-gray-900">A Turnkey Investment Experience</h2>
            <p className="text-gray-600 text-lg mt-2">We handle selection, monitoring and rebalancing—so you can focus on outcomes.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {advantages.map((a, i) => (
              <div key={a.title} data-aos="fade-up" data-aos-delay={`${150 + i * 100}`} className="p-8 bg-white rounded-2xl shadow-lg border border-gray-100">
                <div className="w-12 h-12 rounded-full bg-[#0056d7] text-white font-semibold flex items-center justify-center mb-5">{String(i+1).padStart(2,'0')}</div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{a.title}</h3>
                <ul className="space-y-2 text-gray-700 text-sm">
                  {a.points.map(pt => (<li key={pt} className="flex items-start gap-2"><span className="mt-1 w-2 h-2 rounded-full bg-[#0056d7]" />{pt}</li>))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-14 text-center">
            <motion.a href="/contact" className="inline-block px-10 py-4 rounded-full bg-gradient-to-r from-[#fbbf24] to-[#f59e0b] text-black font-medium shadow-lg hover:shadow-amber-500/30 transition-colors" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.96 }}>
              Explore Portfolios
            </motion.a>
          </div>
        </div>
      </section>

      {/* Models & Oversight */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
        <div className="max-w-7xl mx-auto px-6">
          <div data-aos="fade-up" className="text-center mb-14">
            <h2 className="text-3xl font-semibold text-gray-900">Institutional‑Style Oversight</h2>
            <p className="text-gray-600 text-lg mt-2">Repeatable methodology, manager research, and risk controls.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[{t:'Strategic Models',d:'Risk‑banded models from conservative income to aggressive growth.'},{t:'Manager Research',d:'Continuous screening and due‑diligence of ETFs/funds.'},{t:'Risk Controls',d:'Tracking error, drawdown bands, and rebalance discipline.'}].map((b,i)=>(
              <div key={b.t} data-aos="fade-up" data-aos-delay={`${150+i*100}`} className="p-8 bg-white rounded-2xl shadow-lg border border-gray-100">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">{b.t}</h3>
                <p className="text-gray-600">{b.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQs */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div data-aos="fade-up" className="text-center mb-10">
            <h2 className="text-3xl font-semibold text-gray-900">Managed Portfolios FAQs</h2>
          </div>
          <div className="space-y-6">
            {[
              {q:'Are these customizable?', a:'Yes—risk bands and objectives can be tailored, and we can accommodate restrictions.'},
              {q:'How often do you rebalance?', a:'We monitor continuously and rebalance when drift or opportunity thresholds are reached.'},
              {q:'What is the typical fee?', a:'Low‑cost ETFs plus a transparent advisory fee; we avoid hidden product commissions.'}
            ].map((f,i)=> (
              <div key={f.q} data-aos="fade-up" data-aos-delay={`${100+i*100}`} className="p-6 rounded-xl bg-gray-50 border border-gray-100">
                <div className="font-semibold text-gray-900 mb-1">{f.q}</div>
                <div className="text-gray-700">{f.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default ManagedPortfolios;


